<div [ngClass]="[
    'bg-blue-grey-9 text-white-high-emphasis center-inner v2-padding-18-b',
    topPadding,
    v2PaddingH
  ]">
  <div [ngClass]="['full-width', maxWidth]">
    <div [ngClass]="[
        sm
          ? 'flex-column-reverse-between-start full-width v2-row-gap-1'
          : 'flex-row-between-start'
      ]">
      <div [ngClass]="
          sm
            ? 'flex-column-between-center full-width'
            : 'flex-row-between-start'
        ">
        <v2-foot-drop *ngIf="showNavi && false"
                      [ngClass]="[sm ? 'full-width' : md ? 'v2-w-9' : 'v2-w-14']"
                      header="NEW"
                      [menu]="[
            { text: 'App', href: host + '/app' },
            { text: 'IRA', href: host + '/ira' }
          ]"
                      [disabled]="!sm"
                      [hideToggle]="!sm"
                      [expanded]="!sm">
        </v2-foot-drop>
        <v2-foot-drop *ngIf="showNavi"
                      [ngClass]="[
            sm
              ? 'full-width'
              : md
              ? 'v2-w-9 v2-margin-4-r'
              : 'v2-w-14  v2-margin-4-r'
          ]"
                      header="SUPPORT"
                      [menu]="[
            {
              text: 'FAQ',
              href: 'https://ark7.com/help',
              target: '_blank'
            },
            {
              text: 'Step-by-step Instructions',
              href:
                'https://ark7.com/faq-category?categoryId=665735f1c98b64d91bc97431',
              target: '_blank'
            },
            {
              text: 'Contact',
              href: host + '/contact'
            }
          ]"
                      [disabled]="!sm"
                      [hideToggle]="!sm"
                      [expanded]="!sm">
        </v2-foot-drop>
        <v2-foot-drop [ngClass]="[sm ? 'full-width' : md ? 'v2-w-9' : 'v2-w-14']"
                      header="LEGAL"
                      [menu]="[
            {
              text: 'SEC Filings',
              href:
                'https://www.sec.gov/cgi-bin/browse-edgar?company=ark7&match=&CIK=&filenum=&State=&Country=&SIC=&owner=exclude&Find=Find+Companies&action=getcompany',
              target: '_blank'
            },
            {
              text: 'Terms & Conditions',
              href: host + '/terms-and-conditions'
            },
            {
              text: 'Privacy Policy',
              href: host + '/privacy-policy'
            }
          ]"
                      [disabled]="!sm"
                      [hideToggle]="!sm"
                      [expanded]="!sm">
        </v2-foot-drop>
      </div>
      <div class="flex-scale"></div>
      <div [ngClass]="[
          sm ? 'flex-column-between-start' : 'flex-column-between-end'
        ]">
        <v2-logo [ngClass]="['v2-margin-3-b']"
                 filter="brightness(0) invert(1)"
                 [height]="sm ? '24px' : '32px'"></v2-logo>
        <div class="flex-row-between-center"
             [ngClass]="[
            xs ? 'v2-col-gap-16px' : md ? 'v2-col-gap-16px' : 'v2-col-gap-20px'
          ]">
          <a href="https://www.tiktok.com/@ark7official"
             target="_blank">
            <img src="/assets/tiktok.svg"
                 alt="tiktok"
                 [ngClass]="['svg-white', sm ? 'v2-h-3' : 'v2-h-4']" />
          </a>
          <a href="https://www.instagram.com/ark7official/"
             target="_blank">
            <img src="/assets/instagram.svg"
                 alt="instagram"
                 [ngClass]="['svg-white', sm ? 'v2-h-3' : 'v2-h-4']" />
          </a>
          <a href="https://www.facebook.com/Ark7Official"
             target="_blank">
            <img src="/assets/v2-media/Facebook.svg"
                 alt="facebook"
                 [ngClass]="['svg-white', sm ? 'v2-h-3' : 'v2-h-4']" />
          </a>
          <a href="https://www.linkedin.com/company/ark7official"
             target="_blank">
            <img src="/assets/v2-media/LinkedIn.svg"
                 alt="linkedin"
                 [ngClass]="['svg-white', sm ? 'v2-h-3' : 'v2-h-4']" />
          </a>
        </div>
      </div>
    </div>
    <hr *ngIf="!sm"
        class="v2-margin-2-t v2-margin-4-b color-green-grey-6 v2-border-1px" />
    <div class="">
      <div *ngIf="showAppDisclaimer"
           class="v2-margin-2-b">
        <div class="">* Disclaimer</div>
        <div *ngIf="showAppDisclaimer"
             class="color-green-grey-3 label-2 v2-margin-2-t">The Ark7 Real Estate Investing App’s ranking is based on
          search
          results for ‘Ark7 Real Estate Investing’ and ‘Real Estate Investing App’ on Apple’s App Store as of August
          23, 2024. Rankings may vary by region, device, and search terms.</div>
      </div>

      <div class="full-width flex-row-between-center v2-margin-2-b">
        <div>&copy; 2026 Ark7 Inc.</div>
        <img class="v2-h-4"
             alt="Accredited business"
             src="/assets/v2-aplus.webp" />
      </div>
      <div class="label-2 text-justify color-green-grey-3">
        <p>
          Ark7 Inc. ("Ark7") operates the
          <a href="https://ark7.com">ark7.com</a> website (the “Site”)
          and the mobile application (the “App”). Ark7 serves as manager to Ark7 Properties LLC, Ark7 Properties Plus LLC
          and Ark7 Properties Advance LLC, and such companies shall be collectively referred to herein as “Ark7
          Properties”.
          Neither Ark7 nor Ark7 Properties is a broker-dealer or an investment advisor. The offer and sale of securities
          through the Site and/or the App is facilitated through Dalmore Group LLC, a
          registered broker-dealer and member of
          <a href="https://www.finra.org/"
             target="_blank">FINRA</a> and
          <a href="https://www.sipc.org/"
             target="_blank">SIPC</a>, located at
          525 Green Place, Woodmere, NY 11598. Information on all
          FINRA-registered broker-dealers can be found on FINRA’s
          <a href="https://brokercheck.finra.org/"
             target="_blank">BrokerCheck</a>.
        </p>
        <p>
          Investing in securities involves risks, and there is always the potential of losing money when you invest in
          securities. Past performance is no guarantee of future results. Investments such as those on the Ark7 platform
          are speculative and involve substantial risks to consider before investing, outlined in the respective offering
          materials and including, but not limited to, illiquidity, lack of diversification, and complete loss of
          capital. Key risks also include, but are not limited to, limited operating history of certain series, lack of
          voting rights, and reliance on the Ark7 platform for administration and potential liquidity. An investment in
          an offering constitutes only an investment in a particular series and not in Ark7 or
          any of the underlying asset(s). Investors should carefully review the risks located in the respective offering
          materials for a more comprehensive discussion of risks.
        </p>
        <p>
          You should consult with your financial advisor, accountant, and/or attorney when evaluating any offering.
          Neither Ark7, any Ark7 Properties entity or series, nor Dalmore provides investment advice or makes investment
          recommendations, and no communication through the Site, the App, or any other medium should be construed as
          such.
        </p>
        <p>
          The Site and/or the App may contain forward-looking statements. You should not rely on such statements when
          making an investment decision and should carefully evaluate the applicable offering materials, including the
          complete set of risk factors provided in the offering circular. The applicable offering circulars and periodic
          reports for each Ark7 Properties entity and series are available through the SEC filings section of the Site.
        </p>
        <p>
          From time to time, Ark7 will seek to qualify additional series offerings of securities under regulation A. For
          offerings that have not yet been qualified, no money or other consideration is being solicited and, if sent in
          response, will not be accepted. No offer to buy securities of a particular offering can be accepted, and no
          part of the purchase price can be received, until an offering statement filed with the Securities and Exchange
          Commission (the "SEC") relating to that series has been qualified by the SEC. Any such offer may be withdrawn
          or revoked, without obligation or commitment of any kind, at any time before notice of acceptance given after
          the date of qualification by the SEC. An indication of interest involves no obligation or commitment of any
          kind.
        </p>
        <p>
          Investment overviews contained on the Site and/or the App contain summaries of the purpose and the principal
          business terms of the investment opportunities. Such summaries are intended for informational purposes only and
          do not purport to be complete, and each is qualified in its entirety by reference to the more detailed
          discussions contained in the applicable offering circular filed with the SEC. None of the Ark7 Properties
          entities offers refunds after an investment has been made, except as may be required by applicable law. Please
          review the relevant offering materials and subscription documentation for additional information.
        </p>
        <p>
          All securities (“Shares”) will be issued in electronic form only and will not be listed or quoted on any
          securities exchange. There can be no assurance that any secondary market for Shares will develop or be
          sustained. Even if a secondary market becomes available, it may be limited, illiquid, or unavailable to
          residents of certain states, and market prices may fluctuate or decline below the purchase price. For these
          reasons, investors must be prepared to hold their Shares indefinitely.
        </p>
      </div>
    </div>
  </div>
</div>
